<template>
  <div>
    <h2>Dashboard Pacientes</h2>
    <p>Bienvenido al dashboard de pacientes.</p>
    <div class="card" style="padding:10px">
      <div class="row">
        <div class="col-md-12" id="form-search-patient">
          <div class="row">
            <form
              @submit.prevent="getInformation"
              class="row"
              style="width:100%; margin:0; padding:10px"
            >
              <div class="col-md-3">
                <select
                  name="paciente"
                  id="paciente"
                  v-model="paciente"
                  class="form-control"
                  required
                >
                  <option value="" disabled selected
                    >Seleccione un paciente</option
                  >
                  <option
                    v-for="paciente in pacientes"
                    :key="paciente.PacIdeUsu"
                    :value="paciente.PacIdeUsu"
                  >
                    {{ paciente.PacNom1 }} {{ paciente.PacApe1 }}
                  </option>
                </select>
              </div>
              <div class="col-md-3">
                <button
                  type="submit"
                  class="btn btn-success btn-fill"
                  style="border-radius:7px"
                >
                  Buscar información <i class="fa fa-search"></i>
                </button>
              </div>
            </form>
          </div>
          <div class="row"></div>
        </div>
      </div>
    </div>

    <div class="" v-if="basic_information !== null">
      <modalPaciente :paciente="basic_information"></modalPaciente>
      <div class="row">
        <div class="col-md-6">
          <div class="card card-user" @click="mostrarModalPaciente()">
            <div class="contentt">
              <div class="img-user">
                <img :src="url + basic_information.foto" alt="" />
              </div>
              <div>
                <!-- <h4>Información Básica</h4> -->
                <span class="title-name-paciente"
                  >{{ basic_information.nombres }}
                  {{ basic_information.apellidos }}</span
                >
                <p>
                  <span class="information-paciente"
                    >Nació el
                    <span class="information">{{
                      basic_information.fecha_nacimiento | date
                    }}</span></span
                  >
                  <br />
                  <span class="information-paciente"
                    >Identificación
                    <span class="information">{{
                      basic_information.documento
                    }}</span></span
                  >
                  <br />
                  <span class="information-paciente"
                    >Régimen
                    <span class="information">{{
                      basic_information.regimen == 1
                        ? "Contributivo"
                        : "Subsidiado"
                    }}</span></span
                  >
                  <br />
                  <span class="information-paciente"
                    >Diagnosticado con
                    <span class="information">{{
                      basic_information.diagnostico
                    }}</span></span
                  >
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-2">
          <div class="card-calendar">
            <div class="mes">
              {{ fechaAultimaAtencion.mes.toUpperCase() }}, {{ fechaAultimaAtencion.year }}
            </div>
            <div class="dia">
              {{ fechaAultimaAtencion.dia }}
            </div>
            <div>
              <span class="normal-text">Ultima atención</span>
            </div>
          </div>
        </div>
        <div class="col-md-4">
          <div class="card-servicios">
            <div class="informacion" style="flex:3">
              <span class="titulo">ORDENES Y AUTORIZACIONES</span><br />
              <br />
              <span class="normal-text">{{ bolsaTotal }} sesiones disponibles</span> <br />
              <span class="normal-text"
                >{{ autorizacionesActivas.length }} autorizaciones</span
              >
              <br />
              <span class="normal-text"
                >{{ ordenesActivas.length }} ordenes</span
              >
              <br /> <br>
              <span class="indicador-lugar" v-if="indicadorAutorizacion"
                >Autorización próxima a vencer</span
              > <br />
              <span class="indicador-lugar" v-if="bolsaTotal < 15"
                >La bolsa se está agotando</span
              >
            </div>

            <div class="grafica" style="flex:2">
              <i class="fa fa-folder" style="font-size:150px; color:#e3117db8"></i>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-4">
          <div class="card-eventos">
            <div class="" style="padding-bottom: 30px;">
              <span class="titulo">Últimas sesiones realizadas</span>
            </div>
            <div class="content-events">
              <div class="evento" v-for="evento in ultimas_sesiones">
                <div>
                  <i class="fa fa-circle" style="color:green;"></i>
                </div>
                <div style="flex:4;">
                  <span class="titulo-evento">{{ evento.fecha | date }}</span
                  >, {{ evento.hora }} - {{ evento.horaFin }} <br />
                  <span class="normal-text"
                    >{{ evento.nombres }} {{ evento.apellidos }}</span
                  >
                </div>
                <div></div>
                <div style="flex:1;">
                  <span class="indicador-lugar">{{ evento.lugar }}</span>
                </div>
              </div>
            </div>
          </div>
          <br />
          <div class="card-eventos">
            <div class="" style="padding-bottom: 30px;">
              <span class="titulo">Próximas sesiones</span>
            </div>
            <div class="content-events" v-if="proximas_sesiones.length > 0">
              <div class="evento" v-for="evento in proximas_sesiones">
                <div>
                  <i class="fa fa-circle" style="color:blue;"></i>
                </div>
                <div style="flex:4;">
                  <span class="titulo-evento">{{ evento.fecha | date }}</span
                  >, {{ evento.hora }} - {{ evento.horaFin }} <br />
                  <span class="normal-text"
                    >{{ evento.nombres }} {{ evento.apellidos }}</span
                  >
                </div>
                <div></div>
                <div style="flex:1;">
                  <span class="indicador-lugar">{{ evento.lugar }}</span>
                </div>
              </div>
            </div>
            <div v-else>
              <center>
                <span class="normal-text"
                  >{{ MESSAGES.NO_DATA_FOUND }}</span
                >
              </center>
            </div>
          </div>
          <div class="card-recomendacion">
            <div>
              <span class="titulo">Recomendación terapeutica</span> <br /> <br>
              <span class="normal-text" style="font-size:18px"
                >{{ recomendacion[0].recomendacion }}</span
              >
            </div>
          </div>
          <div class="card-lideres">
            <div>
              <span class="titulo">Lideres terapeuticos</span> <br>
              <span class="normal-text"
                >Lideres asignados al paciente, puedes actualizarlos en el modulo de pacientes registrados</span
              >
            </div>
            <div class="content-lideres">  
              <div class="card-lider">
                <span class="titulo-lider">{{ basic_information.lider_fisio != null ? basic_information.lider_fisio : 'No asignado' }}</span>
                <span class="normal-text">Lider fisioterapeuta</span>
              </div>
              <div class="card-lider">
                <span class="titulo-lider">{{ basic_information.lider_teo != null ? basic_information.lider_teo : 'No asignado' }}</span>
                <span class="normal-text">Lider Terapia Ocupacional</span>
              </div>
              <div class="card-lider">
                <span class="titulo-lider">{{ basic_information.lider_fono != null ? basic_information.lider_fono : 'No asignado' }}</span>
                <span class="normal-text">Lider fonoaudiología</span>
              </div>
              <div class="card-lider">
                <span class="titulo-lider">{{ basic_information.lider_psico != null ? basic_information.lider_psico : 'No asignado' }}</span>
                <span class="normal-text">Lider psicología</span>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8">
          <div class="card-evoluciones">
            <div>
              <span class="titulo">Evoluciones del paciente</span> <br />
              <span class="normal-text"
                >Busca evoluciones registradas al paciente en las fechas
                seleccionadas</span
              >
            </div>
            <div class="filtro">
              <form
                style="display: flex; gap: 10px; margin-top: 20px; align-items: flex-end;"
                @submit.prevent="getEvoluciones"
              >
                <div style="flex:2">
                  <label for="fecha-inicial" class="form-label-evoluciones"
                    >Fecha inicial</label
                  >
                  <input
                    type="date"
                    id="fecha-inicial"
                    v-model="fechaInicialEvoluciones"
                    class="form-control input-lg"
                    placeholder="dd/mm/aaaa"
                  />
                </div>
                <div style="flex:2">
                  <label for="fecha-final" class="form-label-evoluciones"
                    >Fecha final</label
                  >
                  <input
                    type="date"
                    id="fecha-final"
                    v-model="fechaFinalEvoluciones"
                    class="form-control input-lg"
                    placeholder="dd/mm/aaaa"
                  />
                </div>
                <div style="flex:1">
                  <button
                    class="btn btn-success btn-lg btn-fill"
                    style="border-radius:7px"
                  >
                    Buscar información <i class="fa fa-search"></i>
                  </button>
                </div>
              </form>
            </div>
            <div class="information-evoluciones">
              <div v-for="evolucion in evoluciones" class="card-evolucion">
                <span class="titulo-evolucion"
                  >{{ evolucion.terapeuta }}, {{ evolucion.fecha | date }}</span
                >
                <br />
                <br />
                <span class="texto-evolucion">{{ evolucion.evolucion }}</span>
                <br />
                <br />
              </div>
            </div>
          </div>

          <div class="card-programaciones-information">
            <div>
              <span class="titulo">Estadisticas de asistencia</span> <br />
            </div>
            <div class="content-informacion-programaciones">
              <div class="informacion-estadisticas">
                <span class="card-detalle-sesiones">
                  <i class="fa fa-circle" style="color:blue"></i> {{ programaciones.total }} sesiones programadas
                </span>
                <span class="card-detalle-sesiones">
                  <i class="fa fa-circle" style="color:green"></i> {{ programaciones.Atendidas }} sesiones cumplidas
                </span>
                <span class="card-detalle-sesiones">
                  <i class="fa fa-circle" style="color:red"></i> {{ programaciones.Canceladas }} sesiones canceladas
                </span>
                <span class="card-detalle-sesiones">
                  <i class="fa fa-circle" style="color:orange"></i> {{ programaciones.SinAtencion }} sesiones sin atención
                </span>
              </div>
              <div class="grafica-estadisticas">
                <div class="chart-circle2" :data-percent="programaciones.porcentajeCumplimiento" ref="chart">
                  <span class="text-chart">
                    {{ programaciones.porcentajeCumplimiento }}%
                  </span>
                </div>
                <small>Porcentaje de cumplimiento</small>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import axiosInstance from "src/global-services/axiosInstance";
import crearAlerta from "../../global-services/crearAlerta";
import modalPaciente from "../Reportes/modals/informacion-paciente.vue";

export default {
  data() {
    return {
      url: "https://avanti-erp.com/",
      pacientes: [],
      paciente: 361,
      basic_information: null,
      proximas_sesiones: [],
      ultimas_sesiones: [],
      autorizacionesActivas: [],
      ordenesActivas: [],
      evoluciones: [],
      fechaAultimaAtencion: {},
      bolsaTotal: 0,
      indicadorAutorizacion: false,
      recomendacion: "",
      programaciones: {},

      fechaInicialEvoluciones: "",
      fechaFinalEvoluciones: "",



      MESSAGES: {
        NO_PACIENTE_SELECTED: "No ha seleccionado un paciente",
        NO_DATA_FOUND: "No hay datos para mostrar",
      },
    };
  },
  components: {
    modalPaciente
  },
  methods: {
    getPacientes: async function() {
      try {
        this.$modal.show("carga");
        const response = await axiosInstance.get("api/pacientesSelect");
        this.pacientes = response.data.data;
      } catch (error) {
        crearAlerta(
          "Error",
          "No se pudo cargar la información de pacientes",
          "error"
        );
        console.error(error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    getInformation: async function() {
      this.$modal.show("carga");
      try {
        const response = await axiosInstance.get(
          `api/paciente-dashboard-information/${this.paciente}`
        );
        this.basic_information = response.data.information[0];
        this.proximas_sesiones = response.data.proximasSesiones;
        this.ultimas_sesiones = response.data.ultimasSesiones;
        this.autorizacionesActivas = response.data.autorizacionesActivas;
        this.ordenesActivas = response.data.ordenesActivas;
        this.evoluciones = response.data.evoluciones;
        this.bolsaTotal = this.obtenerBolsaTotal(this.autorizacionesActivas);
        this.indicadorAutorizacion = this.validarVencimientoAutorizacion(this.autorizacionesActivas);
        this.recomendacion = response.data.recomendacion;
        this.programaciones = response.data.estadisticasTerapias[0];
        this.programaciones.total = parseInt(response.data.estadisticasTerapias[0].Atendidas) + parseInt(response.data.estadisticasTerapias[0].Canceladas) + parseInt(response.data.estadisticasTerapias[0].SinAtencion);
        this.programaciones.porcentajeCumplimiento = ((parseInt(response.data.estadisticasTerapias[0].Atendidas) / this.programaciones.total) * 100).toFixed(2);
        if (this.ultimas_sesiones.length > 0) {
          this.fechaAultimaAtencion = this.obtenerMesYDia(
            this.ultimas_sesiones[0].fecha
          );
        }



        let EasyPieChart = await import("easy-pie-chart");
        this.renderChart(EasyPieChart);
      } catch (error) {
        crearAlerta(
          "Error",
          "No se pudo cargar la información del paciente seleccionado",
          "error"
        );
        console.error(error);
      } finally {
        this.$modal.hide("carga");
      }
    },
    mostrarModalPaciente: function() {
      this.$modal.show("informacion-paciente-dashboard");
    },
    renderChart(EasyPieChart) {
      /* eslint-disable no-new */
      this.chart = new EasyPieChart(this.$refs.chart, {
        lineWidth: 25,
        size: 160,
        scaleColor: false,
        trackColor: "#f3aed587",
        barColor: "#e3117dc9",
        animate: { duration: 1000, enabled: true }
      });
    },
    obtenerBolsaTotal: function(autorizaciones){
      return autorizaciones.reduce((total, item) => {
        return total + item.bolsa;
      }, 0);
    },
    obtenerMesYDia(fechaInput) {
      const mesesAbreviados = [
        "ene",
        "feb",
        "mar",
        "abr",
        "may",
        "jun",
        "jul",
        "ago",
        "sep",
        "oct",
        "nov",
        "dic"
      ];

      const fecha = new Date(fechaInput);

      if (isNaN(fecha)) {
        throw new Error("Fecha inválida");
      }

      const mes = mesesAbreviados[fecha.getMonth()];
      const dia = fecha.getDate();
      const year = fecha.getFullYear();

      return {
        mes,
        dia,
        year
      };
    },
    validarVencimientoAutorizacion: function(autorizacionesActivas){
      const hoy = new Date();
      for (let autorizacion of autorizacionesActivas) {
        const fechaVencimiento = new Date(autorizacion.fechaVencimiento);
        const diferenciaDias = Math.ceil((fechaVencimiento - hoy) / (1000 * 60 * 60 * 24));
        if (diferenciaDias <= 15) {
          return true;
        }
      }
      return false;
    },
    getEvoluciones: async function(){
      try{
        this.evoluciones = [];
        this.$modal.show("carga");
        let lokedInformation = 0;
        const response = await axiosInstance.get(
          `api/obtener-evoluciones/${this.paciente}/${this.fechaInicialEvoluciones}/${this.fechaFinalEvoluciones}/${lokedInformation}`
        );
        let evoluciones = [];
        for (let i = 0; i < response.data.data.length; i++) {
            evoluciones.push({
              terapeuta:
              response.data.data[i].nombres + " " + response.data.data[i].apellidos,
              evolucion: response.data.data[i].Obs,
              fecha: response.data.data[i].EvoFec,
            });
        }
        this.evoluciones = evoluciones;
      }catch(error){
        console.error(error);
      }finally{
        this.$modal.hide("carga");
      }
    }
  },
  async mounted() {
    this.getPacientes();
  }
};
</script>

<style scoped>
.card {
  border-radius: 10px !important;
  box-shadow: none !important;
}

.evento {
  /* background-color: aliceblue; */
  /* border-left: 3px solid green; */
  gap: 15px;
  /* border:1px solid #e0e0e0; */
  padding: 10px;
  background-color: #fafafa;
  display: flex;
  align-items: center;
  padding: 10px;
  border-radius: 8px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: 0.2s ease-in-out;
  animation: 1s fadeIn;
}

.contentt {
  padding: 15px;
  display: flex;
}

.list-event {
  list-style: none;
  padding-left: 0;
}
.content-icon {
  position: relative;
  width: 300px;
  height: 200px;
  overflow: hidden;
}

.icon-card {
  color: aliceblue;
  position: relative;
  font-size: 280px;
  padding-left: 110px;
  transition: 0.3s ease-in-out;

  &:hover {
    /* padding-left: 10px; */
    color: #e3ffdc;
  }
}

.card-user {
  height: 230px;
  cursor: pointer;
}

.card-calendar {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 230px;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 10px;

  &:hover {
    transform: translateY(-8px);
    transition: all 0.3s ease;
  }
}

.mes {
  font-size: 30px;
  font-weight: bold;
  color: #c6c6c6;
  padding: 0;
  margin: 0;
}

.dia {
  padding: 0;
  margin: 0;
  font-size: 100px;
  font-weight: 700;
  color: #2f2254;
}

.img-user {
  width: 200px;
  height: 200px;
  overflow: hidden;
  border-radius: 10px;
  margin-right: 20px;
}

.title-name-paciente {
  font-size: 30px;
  font-weight: bold;
  line-height: normal;
  color: #e3097e;
}

.information-paciente {
  font-size: 17px;
  font-weight: 300;
  line-height: normal;
  padding-top: 0px;
  color: rgb(131, 131, 131);
}

.information-paciente .information {
  color: black;
  font-weight: 400;
}

.card-servicios {
  height: 230px;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 25px;
  display: flex;
  gap: 30px;
  align-items: center;

  &:hover {
    transform: translateY(-8px);
    transition: all 0.3s ease;
  }
}

.titulo {
  font-size: 25px;
  font-weight: 600;
  line-height: 0.9;
  color: #2f2254;
  margin-bottom: 10px;
}

.titulo-evento {
  font-size: 15px;
  font-weight: 500;
  line-height: 0.9;
  color: #2f2254;
  margin-bottom: 10px;
}

.normal-text {
  font-size: 16px;
  font-weight: 300;
  line-height: normal;
  color: rgb(131, 131, 131);
}

.chart-circle2 {
  /* display: inline-block; */
  font-size: 1.3em;
  height: 160px;
  line-height: 160px;
  /* margin-top: 30px; */
  margin-bottom: 15px;
  position: relative;
  text-align: center;
  width: 160px;

  canvas {
    position: absolute;
    top: 0;
    left: 0;
  }

  &:hover {
    transform: scale(1.2);
    transition: all 0.3s ease;
  }
}

.text-chart {
  font-size: 22px;
  font-weight: 300;
  color: #e3097e;
}

.card-eventos {
  /* height: 500px; */
  background-color: #ffffff;
  border-radius: 10px;
  padding: 25px;

  &:hover {
    transform: translateY(-8px);
    transition: all 0.3s ease;
  }
}

.indicador-lugar {
  background-color: #e3097e1a;
  color: #e3097e;
  padding: 3px 8px;
  border-radius: 20px;
  font-size: 12px;
  font-weight: 500;
}

.card-evoluciones {
  height: 1000px;
  background-color: #ffffff;
  border-radius: 10px;
  padding: 25px;

  &:hover {
    transform: translateY(-8px);
    transition: all 0.3s ease;
  }
}

label.form-label-evoluciones {
  font-weight: 400;
  font-size: 15px;
  line-height: normal;
  color: #2f2254;
}

.card-evolucion {
  background-color: #fafafa;
  border-radius: 8px;
  padding: 15px;
  margin-bottom: 15px;
}

.information-evoluciones {
  margin-top: 20px;
  height: 750px;
  overflow-y: scroll;
}

.titulo-evolucion {
  font-weight: 400;
  font-size: 15px;
  color: #2f2254;
}

.texto-evolucion {
  font-weight: 300;
  font-size: 18px;
  color: rgb(131, 131, 131);
}
.card-recomendacion {
  /* color del postick */
  background-color: #fff70a6a;
  border-radius: 10px;
  padding: 25px;
  margin-top: 20px;

  &:hover {
    transform: translateY(-8px);
    transition: all 0.3s ease;
  }
}

.card-lideres {
  /* height: 200px; */
  background-color: #ffffff;
  border-radius: 10px;
  padding: 25px;
  margin-top: 20px;
  margin-bottom: 30px;

  &:hover {
    transform: translateY(-8px);
    transition: all 0.3s ease;
  }
}

.card-lider{
  background-color: #fafafa;
  border-radius: 7px;
  display: flex;
  flex-direction: column;
  padding: 10px;
}

.content-lideres{
  display: flex;
  margin-top: 15px;
  flex-direction: column;
  gap: 10px;
}

.titulo-lider{
  font-size: 18px;
  font-weight: 450;
  line-height: 0.9;
  color: #2f2254;
  margin-bottom: 5px;
}

.card-programaciones-information {
  background-color: #ffffff;
  border-radius: 10px;
  padding: 25px;
  margin-top: 20px;

  &:hover {
    transform: translateY(-8px);
    transition: all 0.3s ease;
  }
}

.content-informacion-programaciones{
  display: flex;
  align-items: center;
  gap: 50px;
  margin-top: 15px;
}

.informacion-estadisticas {
  display: flex;
  flex-direction: column;
  gap: 5px;
  width: 78%;
}

.filtro-estadisticas-programacion{
  margin-bottom: 36px;
}

.card-detalle-sesiones{
  font-size: 16px;
  font-weight: 300;
  line-height: normal;
  color: rgb(131, 131, 131);
  background-color: #fafafa;
  padding: 8px;
  border-radius: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/Reportes/dashboardPacientes.vue